import React from 'react';
import { SecondaryButton, ButtonIcon } from '@hz-design-system/web-ui';
import getSuitCSSClasses from '@/utils/getSuitCSSClasses';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

const classes = {
  root: getSuitCSSClasses({ namespace: 'hz', name: 'SaveSellerControl' }),
  label: getSuitCSSClasses({ namespace: 'hz', name: 'SaveSellerControl-followLabel' }),
};

interface SaveSellerControlProps {
  sellerId: number;
  isSavedSeller: boolean;
  onClick: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  loading?: boolean;
}

const SaveSellerControl: React.FC<SaveSellerControlProps> = ({ onClick, sellerId, isSavedSeller, loading = false }) => {
  const { t } = useI18nContext();

  return (
    <div className={classes.root}>
      <div id="save-seller">
        <form id="save-seller-form" action="">
          <input name="sellerId" type="hidden" value={sellerId} />
          <SecondaryButton onClick={onClick} title={t('soi.sellerHeader.buttonTitleFollowSeller')} disabled={loading}>
            <ButtonIcon name={isSavedSeller ? 'following' : 'follow'} isStartIcon={false} />
          </SecondaryButton>
        </form>
      </div>
    </div>
  );
};

export default SaveSellerControl;
